import { IExtractedField } from 'types/db/ExtractedProForma';
import { ApartmentResolvers } from '../../layout/buildBlocks';
import { extractedAssumptionsResolver } from './assumptions';
import { extractedDetailsResolver } from './details';
import { extractedDevelopmentResolver } from './development';
import { extractedForecastResolver } from './forecast';
import { extractedOperationsResolver } from './operations';
import { extractedReturnsResolver } from './returns';

export const extractedResolvers = (fields: IExtractedField[]): ApartmentResolvers => ({
    details: extractedDetailsResolver(fields),
    assumptions: extractedAssumptionsResolver(fields),
    forecast: extractedForecastResolver(fields),
    returns: extractedReturnsResolver(fields),
    development: extractedDevelopmentResolver(fields),
    operations: extractedOperationsResolver(fields),
});
